import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import Seo, { breadcrumbJsonLd } from "@/components/Seo";
import { Breadcrumbs, StarRating } from "@/components/common";
import { REVIEWS, SITE } from "@/mock";

export default function Reviews() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "Reviews", path: "/reviews" },
  ];
  return (
    <>
      <Seo
        title="Customer Reviews - 5-Star Rated Mattress Store"
        description={`Read ${SITE.reviewCount}+ five-star reviews for MattressTown in Fort Lauderdale. Honest pricing, expert service and fast delivery.`}
        path="/reviews"
        jsonLd={breadcrumbJsonLd(crumbs)}
      />
      <Breadcrumbs items={crumbs} />

      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="rounded-2xl bg-neutral-900 p-8 text-center text-white">
          <StarRating value={5} size={26} className="justify-center" />
          <p className="mt-3 text-5xl font-bold">{SITE.rating.toFixed(1)}</p>
          <p className="mt-1 text-neutral-300">Based on {SITE.reviewCount}+ Google Reviews</p>
          <a href={SITE.googleReviewUrl} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#D0021B] px-7 py-3 text-sm font-bold uppercase tracking-wide text-white hover:bg-[#a80016]"><Star className="h-4 w-4" aria-hidden="true" /> Write a Review</a>
        </div>

        <h1 className="mt-12 text-3xl font-bold uppercase text-neutral-900">What Our Customers Say</h1>
        <div className="mt-6 grid gap-6 md:grid-cols-2">
          {REVIEWS.map((r) => (
            <figure key={r.name} className="rounded-xl border border-neutral-200 bg-white p-6 shadow-sm">
              <div className="flex items-center justify-between">
                <figcaption className="font-bold text-neutral-900">{r.name}</figcaption>
                <span className="text-xs text-neutral-500">{r.date}</span>
              </div>
              <StarRating value={r.rating} className="mt-1" />
              <blockquote className="mt-3 leading-relaxed text-neutral-700">“{r.text}”</blockquote>
            </figure>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link to="/mattresses" className="inline-block rounded-full border-2 border-neutral-900 px-8 py-3 text-sm font-bold uppercase tracking-wide text-neutral-900 hover:bg-neutral-900 hover:text-white">Shop Mattresses</Link>
        </div>
      </div>
    </>
  );
}
